import { GenericSectionThemeType, MenuItemType } from '@utils/types'
import { SwiperSlide } from 'swiper/react'
import { AnchorCard } from '@components/molecules'
import { GenericSection, GenericSlider } from '@components/organisms'
import styles from './AnchorSection.module.sass'

interface Props {
  item: MenuItemType
  theme?: GenericSectionThemeType
  editMode?: boolean
  className?: string
}

const AnchorSection = (props: Props) => {
  const { item = undefined, theme = 'neutral10', editMode = false, className = '' } = props

  return item?.children?.length > 0 || editMode ? (
    <GenericSection
      item={item}
      theme={theme}
      editMode={editMode}
      className={`${styles.root} ${editMode ? styles['root--editMode'] : ''} ${className}`}
    >
      {!editMode && !!item?.children?.length && (
        <GenericSlider
          conf={{
            slidesPerView: 1.2,
            spaceBetween: 20,
            breakpoints: {
              576: {
                slidesPerView: 2.2,
              },
              768: {
                slidesPerView: 3.2,
              },
            },
          }}
          className={styles.slider}
        >
          {item.children.map((item, idx) => (
            <SwiperSlide key={idx}>
              <AnchorCard item={item} />
            </SwiperSlide>
          ))}
        </GenericSlider>
      )}
      {editMode ? (
        <>{item?.children}</>
      ) : (
        !!item?.children?.length && (
          <div className={styles.grid}>
            {item.children.map((x) => (
              <AnchorCard item={x} key={x.pk} />
            ))}
          </div>
        )
      )}
    </GenericSection>
  ) : (
    <></>
  )
}

export default AnchorSection
